import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mobile } from '../../styles/media'
import { formatArtworkNumber } from '../../helper/card'

const Artwork = ({ category, number }) => {
	const isOcg = number > 100

	return (
		<StyledArtwork>
			<ArtworkNumber number={number} category={category}>
				<span>#</span>&nbsp;{formatArtworkNumber(number)}
			</ArtworkNumber>
			{category && (
				<ArtworkCategory>
					{category === 'extended-art' && !isOcg && 'EXTD'}
					{category === 'lost-art' && !isOcg && 'LART'}
					{category === 'original' && !isOcg && 'Original'}
					{isOcg && 'OCG'}
				</ArtworkCategory>
			)}
		</StyledArtwork>
	)
}

Artwork.propTypes = {
	category: PropTypes.string,
	number: PropTypes.number.isRequired
},

Artwork.defaultProps = {
	category: null
}

export const StyledArtwork = styled.div`
	align-items: center;
	display: inline-flex;
	gap: 0.35rem;
`

const ArtworkNumber = styled.span`
	background: ${props => props.number > 1 ? props.theme.sage : props.theme.secondary};
	border-radius: 2px;
	color: #FFF;
	font-size: 0.7rem;
	font-weight: 700;
	position: relative;

	align-items: center;
	display: inline-flex;
	justify-content: center;

	vertical-align: middle;

	height: 18px;
	min-width: 22px;
	padding: 0 0.25rem;

	span {
		color: rgba(255, 255, 255, 0.5);
		font-weight: 500;
	}

	${props => props.number > 100 && `
		background: ${props.theme.teal};
	`}

	${mobile`
		font-size: 0.6rem;
		margin-left: 0.25rem;

		height: 15px;
		min-width: 18px;
		padding: 0 0.2rem;
	`}
`

const ArtworkCategory = styled.span`
	color: ${props => props.theme.textLight};
	font-size: 0.8rem;
	font-weight: 600;

	${mobile`
		font-size: 0.7rem;
	`}
`

export default Artwork
